import React from 'react'
import { signIn } from 'next-auth/react'

import useTranslation from 'next-translate/useTranslation'
import { useForm } from 'react-hook-form'
import Link from 'next/link'
import { useRouter } from 'next/router'
import AppInput from '../atoms/Application/AppInput'

type FormData = {
  email: string
  password: string
}

export type LoginCandidateFormProps = {
  withResetPassword?: boolean
  withForgotPassword?: boolean
}

const LoginCandidateForm = ({
  withResetPassword = true,
  withForgotPassword = true,
}: LoginCandidateFormProps) => {
  const { t } = useTranslation('common')

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm()

  const router = useRouter()

  const onSubmit = async (data: FormData) => {
    const { email, password } = data

    const error = await signIn('email_password', {
      redirect: false,
      email,
      password,
    })

    if (error) {
      setError('email', {
        message: t('validation_messages:invalid_credentials'),
      })
    }
  }

  return (
    <>
      <form
        onSubmit={handleSubmit(async (data) => {
          try {
            await onSubmit(data as FormData)
          } catch (e) {
            console.log(e)
          }
        })}
      >
        <AppInput
          errors={errors}
          isActive={{}}
          options={{ ...register('email', { required: true }) }}
          required
          label={t('common:email')}
        />
        <AppInput
          errors={errors}
          isActive={{}}
          options={{ ...register('password', { required: true }) }}
          required
          label={t('common:password')}
          type='password'
        />
        {withResetPassword && (
          <div className='flex justify-end pb-6'>
            <Link
              href='/auth/recover_password'
              prefetch={false}
              className='font-medium text-sm underline hover:no-underline'
            >
              {t('common:not_remember_password')}
            </Link>
          </div>
        )}
        <input
          type='submit'
          value={t('common:login')}
          className='primary mt-5 w-full focus:outline-none transition ease-in-out duration-300 cursor-pointer rounded-full  whitespace-nowrap relative inline-block py-2 px-9 text-base bg-primary hover:bg-primary-hover text-white border-3 border-primary hover:border-primary-hover font-normal'
        />
      </form>
      {withForgotPassword && (
        <div className='flex justify-center mt-8'>
          <Link
            href={{ pathname: '/auth/register', query: router.query }}
            prefetch={false}
            legacyBehavior
          >
            <div>
              <span className='font-normal'>{t('common:missing_account')}</span>{' '}
              <a className='cursor-pointer	font-medium text-sm underline hover:no-underline'>
                {t('common:sign_up')}
              </a>
            </div>
          </Link>
        </div>
      )}
    </>
  )
}

export default LoginCandidateForm
